import { Box, Grid, Pagination, Paper, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import CarContainer1, { NormalCard, CarListingCard, VehicleListingCard } from '@common/pages/Dashboard/components/CarContainer1';
import theme from '../../../../theme';
import CarsList from '@common/pages/Dashboard/components/CarsList';

import {
  useLazyGetCarsInNegotiationBuyNowQuery,
  useLazyGetCarsInNegotiationQuery,
} from '../../../../toolkit/carsInNegotiation/carsInNegotiationApi';

import { baseImageUrl } from '@common/api';
import debounce from 'lodash.debounce';

import { useLocation } from 'react-router-dom';
import { routes } from 'src/utils/constants/routes';
import { carContainerTypes } from '@common/utils/constants/ui/carContainers';
import { auctionTypes } from '@common/utils/constants/auction';
import { useListenForNewCarsInNego } from './customHooks/useListenForNewCarsInNego';

const CarsInNegotationList = ({ selectedCar, setSelectedCar, paginationHandler, onCarClick }) => {
  // Add translation hook
  const { t } = useTranslation(['carsInNegotiation', 'common']);

  // MUI hooks
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  // static data start....
  const paginationDataInit = React.useMemo(() => {
    return {
      current_page: 1,
      data: [],
      last_page: 1,
    };
  }, []);
  // static data end....

  // useLocation...
  const location = useLocation();
  // useLocation...

  const subRoute = location?.pathname?.split?.(`${routes?.dashboardNavigation}/`)?.[1];
  const liveAuctionOrBuyNow = location?.pathname?.includes?.(`${routes.carsInNegotiationBuyNow}`)
    ? auctionTypes.buyNow
    : auctionTypes.liveAuction;

  console.log(subRoute, liveAuctionOrBuyNow, `subRoute`);

  const onNewCarInNegoHandler = async (vehicle) => {
    await fetchPaginationDataHandler({});
  };

  // custom hooks start...
  const [getCarsInNegotiationApiHandler] = useLazyGetCarsInNegotiationQuery();
  const [getCarsInNegotiationBuyNowApiHandler] = useLazyGetCarsInNegotiationBuyNowQuery();
  useListenForNewCarsInNego({
    onNewCarInNegoHandler: onNewCarInNegoHandler
  });
  // custom hooks end...

  const [selectedMakes] = React.useState(['']);
  const [selectedModels] = React.useState(['']);
  const [selectedYearFrom] = React.useState('');
  const [selectedYearTo] = React.useState('');
  const [odometerFrom] = React.useState('');
  const [odometerTo] = React.useState('');
  const [paginationData, setPaginationData] = React.useState(paginationDataInit);

  const handlePageChange = (e, page) => {
    console.log(page, 'handlePageChange');
    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        current_page: page,
      };
    });
  };

  const fetchPaginationDataHandler = async ({ params }) => {
    let res;

    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        isFetching: true,
      };
    });

    console.log(`fetchPaginationDataHandler`);

    // res1 = await getCarsInNegotiationApiHandler({
    //   params: {
    //     page: paginationData?.current_page,
    //     per_page: paginationData?.per_page,
    //   }
    // });

    if (subRoute === routes?.carsInNegotiation?.split?.('/')?.[1]) {
      res = await getCarsInNegotiationApiHandler({
        params: {
          page: paginationData?.current_page,
          per_page: paginationData?.per_page,
        },
      });
    } else {
      res = await getCarsInNegotiationBuyNowApiHandler({
        params: {
          page: paginationData?.current_page,
          per_page: paginationData?.per_page,
        },
      });
    }

    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        data: [
          // ...(res?.data?.Vehicle?.data || res?.data?.Vehicle) || [],
          ...(res?.data?.Vehicle?.data || res?.data?.Vehicle || []),
        ],
        isFetching: false,
        last_page: res?.data?.Vehicle?.last_page,
      };
    });
  };

  // useEffect start...
  React.useEffect(() => {
    const debouncedFetchData = debounce(async () => {
      await fetchPaginationDataHandler({
        params: {
          Year: selectedYearFrom,
          Make: selectedMakes?.map((item) => item?.label)?.join(','), // Pass make names
          Model: selectedModels?.map((item) => item?.label)?.join?.(','), // Pass model names
          from_year: selectedYearFrom,
          to_year: selectedYearTo,
          from_Mileage: odometerFrom,
          to_Mileage: odometerTo,
        },
      });

      // dispatch(
      //   setLiveAuctionMultipleFields({
      //     liveAuctionData: {
      //       ...liveAuction?.liveAuctionData,
      //       data: res?.data?.Vehicle?.data || []
      //     }
      //   })
      // );
    }, 1000);

    debouncedFetchData();

    return () => {
      debouncedFetchData.cancel(); // Cleanup function to cancel pending calls
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    subRoute,
    selectedYearFrom,
    selectedMakes,
    selectedModels,
    selectedYearFrom,
    selectedYearTo,
    odometerFrom,
    odometerTo,
  ]);

  React.useEffect(() => {
    (async () => {
      await fetchPaginationDataHandler({});
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subRoute, paginationData?.current_page]);
  // useEffect end...

  return (
    <Box
      display={'flex'}
      width={'100%'}
      sx={{
        borderRadius: '24px',
        height: {
          lg: `calc(100vh - 92px)`,
          md: `calc(100vh - 92px)`,
          xs: paginationData?.data?.length === 0 ? 'calc(100vh - 112px)' : 'auto',
        },
        position: 'relative',
      }}
    >
      <Box
        sx={{
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          background: theme.palette.background.paper,
          borderRadius: '24px',
          width: '100%',
        }}
      >
        <Paper elevation={0} sx={{ borderRadius: '24px' }}>
          <Box sx={{ padding: { xs: 2, sm: 3, md: 3 } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2, sm: 1 },
              }}
            >
              <Typography
                variant={'h1'}
                sx={{
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                }}
              >
                {/* {t('carsInNegotiation:title')} */}
                {t(
                  liveAuctionOrBuyNow === auctionTypes.liveAuction
                    ? 'Cars in negotiation'
                    : 'Cars in negotiation buy now'
                )}
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box
          sx={{
            height: 'calc(100% - 96px)',
            overflowY: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            scrollbarWidth: 'none !important' /* Firefox */,
            '-ms-overflow-style': 'none' /* IE and Edge */,
            padding: { xs: 2, sm: 3, md: 3 },
            marginBottom: { xs: 3, sm: 3, md: 3 },
          }}
        >
          {paginationData?.isFetching ? (
            // Skeleton UI
            <Box sx={{ height: '100%', width: '100%' }}>
              <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
                {[...Array(8)].map((_, index) => (
                  <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
                    <Box
                      sx={{
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 2,
                        padding: 2,
                        border: `1px solid ${theme.palette.divider}`,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    >
                      {/* Car image skeleton */}
                      <Box sx={{ position: 'relative', marginBottom: 2 }}>
                        <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1.5 }} />

                        {/* Timer skeleton in top right */}
                        <Box
                          sx={{
                            position: 'absolute',
                            bottom: 8,
                            right: 8,
                          }}
                        >
                          <Skeleton variant="rectangular" width={130} height={40} sx={{ borderRadius: 1 }} />
                        </Box>
                      </Box>

                      {/* Car details skeleton */}
                      <Box sx={{ marginBottom: 2 }}>
                        {/* Car title */}
                        <Skeleton variant="text" width="80%" height={24} sx={{ marginBottom: 1 }} />

                        {/* VIN */}
                        <Skeleton variant="text" width="60%" height={16} sx={{ marginBottom: 1 }} />

                        {/* Car specs grid */}
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, marginBottom: 2 }}>
                          {[...Array(4)].map((_, specIndex) => (
                            <Box key={specIndex}>
                              <Skeleton variant="text" width="50%" height={14} sx={{ marginBottom: 0.5 }} />
                              <Skeleton variant="text" width="70%" height={16} />
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : paginationData?.data?.length === 0 ? (
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
                textAlign: 'center',
                marginTop: { xs: '-100px', md: '-200px' },
              }}
            >
              {t('carsInNegotiation:noCarsFound')}
            </Typography>
          ) : (
            <Box sx={{ height: '100%', width: '100%', padding: { xs: 0, sm: 0 } }}>
              <CarsList
                isGarageCar={true}
                showRemainingTime={false}
                // cars={cars}
                cars={paginationData?.data?.map?.((vehicle) => {
                  return {
                    ...vehicle,
                    placeBidBtnLabel: "Start negotiation",
                    showNavigateToDetailsPage: true,
                    navigateToDetailsBtnLabel: "Start negotiation",
                    dontShowCurrentOffer: true,
                    dontShowBuyNow: true,
                    dontShowCountDown: true,
                    vin: vehicle?.VIN,
                    year: vehicle?.Year,
                    make: vehicle?.Make,
                    model: vehicle?.Model,
                    odometer: vehicle?.Mileage,
                    image: vehicle?.Exterior_Image
                      ? `${baseImageUrl}/${vehicle?.Vehicle_Id}/${vehicle?.Exterior_Image}`
                      : ``,
                  };
                })}
                Component={CarContainer1}
                ChildComponent={liveAuctionOrBuyNow === auctionTypes.liveAuction ? CarListingCard : VehicleListingCard}
                onClick={(car) => {
                  console.log(car, `CarsList`);
                  if (onCarClick) {
                    onCarClick(car);
                  }
                }}
                cardType={carContainerTypes.CARS_IN_NEGOTIATION}
              />
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          position: 'absolute',
          bottom: '0px',
        }}
      >
        {paginationData?.last_page > 1 ? (
          <Pagination
            count={paginationData?.last_page}
            page={paginationData?.current_page}
            onChange={handlePageChange}
            sx={{ backgroundColor: '#fff', borderRadius: '4px' }}
            size={isMobile ? 'small' : 'medium'}
            siblingCount={isMobile ? 0 : 1}
            boundaryCount={isMobile ? 1 : 2}
          />
        ) : null}
      </Box>
    </Box>
  );
};

export default CarsInNegotationList;
